<template>
  <div class="backdrop">
    <Square />
    <span class="loading-term" v-if="loadingTermValue">{{ loadingTermValue }}</span>
  </div>
</template>

<script lang="ts">
import Square from './Square.vue';
export default {
  name: 'Loader',
  components: { Square },
  props: {
    loadingTermValue: {
      type: String,
      default: 'Loading',
    },
  },
};
</script>

<style lang="scss" scoped>
.backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.85);
  z-index: 4;
}

.loading-term {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 150%);

  &:first-letter {
    text-transform: uppercase;
  }
}
</style>
